import React, { PropsWithChildren } from 'react';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import CaptchaComponentV3 from './CaptchaComponentV3';

interface Props {
  isAuthorized: boolean;
  isAccessTokenExpired: boolean;
  email: string;
}

const ReAuthenticateComponentV3: React.FC<PropsWithChildren & Props> = ({
  children,
  ...props
}) => {
  return (
    <GoogleReCaptchaProvider
      reCaptchaKey={process.env.INVISIBLE_CAPTCHA_KEY_V3!}
    >
      <CaptchaComponentV3 {...props} />
      {children}
    </GoogleReCaptchaProvider>
  );
};

export default ReAuthenticateComponentV3;
